export enum BlockingObjTypes {
  "Аккаунт" = 1,
  "Договор",
  "Продукт",
  "Предложение",
}
